import React, { useEffect } from 'react';
import PaathshaalaHero from '../components/paathshaala/PaathshaalaHero';
import StoryContrast from '../components/paathshaala/StoryContrast';
import SamplePlayer from '../components/paathshaala/SamplePlayer';
import ForEveryone from '../components/paathshaala/ForEveryone';
import BenefitStrip from '../components/paathshaala/BenefitStrip';
import PaathshaalaCTA from '../components/paathshaala/PaathshaalaCTA';
import PaathshaalaFooter from '../components/paathshaala/PaathshaalaFooter';
import StickyCTA from '../components/paathshaala/StickyCTA';
import GoldDivider from '../components/paathshaala/GoldDivider';
import {
  COLORS,
  FONT_URLS,
  PARCHMENT_GRAIN_STYLE,
  PARCHMENT_FIBERS_STYLE,
  PARCHMENT_STAINS_STYLE,
  PARCHMENT_VIGNETTE_STYLE,
} from '../components/paathshaala/theme';

const PAGE_TITLE = 'Paathshaala — Old stories that hold a mirror to your child’s world';

const SectionDivider: React.FC = () => (
  <div className="py-2">
    <GoldDivider />
  </div>
);

const Paathshaala: React.FC = () => {
  // Load fonts dynamically + set page title
  useEffect(() => {
    const prevTitle = document.title;
    document.title = PAGE_TITLE;

    const links: HTMLLinkElement[] = [];
    FONT_URLS.forEach((url) => {
      const link = document.createElement('link');
      link.href = url;
      link.rel = 'stylesheet';
      document.head.appendChild(link);
      links.push(link);
    });
    return () => {
      document.title = prevTitle;
      links.forEach((link) => document.head.removeChild(link));
    };
  }, []);

  return (
    <div
      className="min-h-screen overflow-x-hidden"
      style={{ backgroundColor: COLORS.parchment }}
    >
      {/* Layered parchment texture — fixed divs (bg-attachment: fixed breaks on iOS Safari) */}
      <div style={PARCHMENT_GRAIN_STYLE} aria-hidden="true" />
      <div style={PARCHMENT_FIBERS_STYLE} aria-hidden="true" />
      <div style={PARCHMENT_STAINS_STYLE} aria-hidden="true" />
      <div style={PARCHMENT_VIGNETTE_STYLE} aria-hidden="true" />

      {/* Thin gold manuscript frame around the viewport */}
      <div
        className="fixed inset-[9px] md:inset-3.5 z-50 pointer-events-none"
        style={{ border: '1px solid rgba(168,137,62,0.45)' }}
        aria-hidden="true"
      >
        <div
          className="absolute inset-[3px] md:inset-1"
          style={{ border: '1px solid rgba(168,137,62,0.18)' }}
        />
      </div>

      <main className="relative z-[1]">
        <PaathshaalaHero />
        <SectionDivider />
        <StoryContrast />
        <SectionDivider />
        <SamplePlayer />
        <SectionDivider />
        <ForEveryone />
        <BenefitStrip />
        <PaathshaalaCTA />
      </main>

      <PaathshaalaFooter />

      <StickyCTA />
    </div>
  );
};

export default Paathshaala;
